import unescapeHtmlEntities from 'lodash-es/unescape';

import { PopoverPlacement } from '@rover/components/src/callouts/Popover/popover.constants';
import { MicrodataHTMLAttributes } from '@rover/components/src/microdata';
import fireDataLayerEvent from '@rover/utilities/fireDataLayerEvent';

export type SitterBadgeProps = {
  className?: string;
  content: string;
  imageUrl: string;
  slug: string;
  title: string;
  width?: number;
  onChange?: (arg0: boolean) => void;
  popoverPlacement?: PopoverPlacement;
} & MicrodataHTMLAttributes;

export function extractTextContent(html: string): string {
  if (process.env.JS_ENV_CLIENT) {
    const div = document.createElement('div');
    div.innerHTML = html;
    return (div.textContent ?? div.innerText).trim();
  }
  return html.replace(/<[^<]+>/g, '').trim();
}

export function unescapeAndExtractText(html: string): string {
  return extractTextContent(unescapeHtmlEntities(html));
}

export function fireBadgeEvent(slug: string): void {
  fireDataLayerEvent({
    event: 'search-badge-hover',
    badgeSlug: slug,
  });
}
